import * as yup from "yup";

export const advertiserFormSchema = yup.object().shape({
    id: yup.number().optional(),
    name: yup.string().required("Advertiser Name is required"),
    logo: yup.mixed<File[]>().optional(),
    link: yup.string().optional(),
});
